import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import RingImg from '../../../Assets/images/magnolia-img/landing-page-img/fine-jewelery-img/rings.png';
import earringsImg from '../../../Assets/images/magnolia-img/landing-page-img/fine-jewelery-img/earrings.png';
import necklacesImg from '../../../Assets/images/magnolia-img/landing-page-img/fine-jewelery-img/necklaces.png';
import braceletsImg from '../../../Assets/images/magnolia-img/landing-page-img/fine-jewelery-img/bracelets.png';
import pendantsImg from '../../../Assets/images/magnolia-img/landing-page-img/fine-jewelery-img/pendants.png';
import size_guideImg from '../../../Assets/images/magnolia-img/landing-page-img/fine-jewelery-img/size_guide.png';

const FineCollection = () => {
  return (
    <>
      <div className="dfl_fine_collection_Section">
        <Container className="dfl_custome_container_staticpage">
          <Row className="w-100 m-auto">
            <Col xs={12} sm={6} md={6} lg={6} className="content_left">
              <div className="banner-adv zoom-image">
                <Row className="ring_bg w-100 m-auto">
                  <Col
                    xs={5}
                    sm={5}
                    md={6}
                    lg={6}
                    className="ring_left_inner no-padding adv-thumb-link"
                  >
                    <img src={RingImg} alt="Rings" />
                  </Col>
                  <Col
                    xs={7}
                    sm={7}
                    md={6}
                    lg={6}
                    className="col-xs-7 content_left_inner"
                  >
                    <h2>Rings</h2>
                    <p>
                      Our rings look stunning irrespective of the event. The
                      person wearing it looks nothing short of perfect.
                    </p>
                    <NavLink to="/jewelry/fashion-rings" className="cool-link">
                      shop rings
                    </NavLink>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs={12} sm={6} md={6} lg={6} className="content_right">
              <div className="banner-adv zoom-image">
                <Row className="earring_bg w-100 m-auto">
                  <Col
                    xs={7}
                    sm={7}
                    md={6}
                    lg={6}
                    className="content_right_inner"
                  >
                    <h2>Earrings</h2>
                    <p>
                      Our earrings will add grace to your entire attire. We have
                      a wide range of hoops, studs, and drop earrings.
                    </p>
                    <NavLink to="/jewelry/earrings" className="cool-link">
                      shop Earrings
                    </NavLink>
                  </Col>
                  <Col
                    xs={5}
                    sm={5}
                    md={6}
                    lg={6}
                    className="dfl_finr_coll_bracelet_img no-padding adv-thumb-link desktop_view"
                  >
                    <img src={earringsImg} alt="Earrings" />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs={12} sm={6} md={6} lg={6} className="content_left">
              <div className="banner-adv zoom-image">
                <Row className="necklaces_bg w-100 m-auto">
                  <Col
                    xs={5}
                    sm={5}
                    md={6}
                    lg={6}
                    className="ring_left_inner no-padding adv-thumb-link"
                  >
                    <img src={necklacesImg} alt="Rings" className="mt-0" />
                  </Col>
                  <Col
                    xs={7}
                    sm={7}
                    md={6}
                    lg={6}
                    className="content_left_inner"
                  >
                    <h2> NECKLACES</h2>
                    <p>
                      Enhance your neck with our jaw dropping necklaces that
                      flatter a simple as well as bold look and looks good on
                      any attire.
                    </p>
                    <NavLink to="/jewelry/necklaces" className="cool-link">
                      shop NECKLACES
                    </NavLink>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs={12} sm={6} md={6} lg={6} className="content_right">
              <div className="banner-adv zoom-image">
                <Row className="bracelets_bg w-100 m-auto">
                  <Col
                    xs={7}
                    sm={7}
                    md={6}
                    lg={6}
                    className="content_right_inner"
                  >
                    <h2> BRACELETS</h2>
                    <p>
                      Express yourself by accessorizing your wrists. We have
                      sleek bracelets, tennis bracelets, bangles and many more
                      options to choose from.
                    </p>
                    <NavLink to="/jewelry/bracelets" className="cool-link">
                      shop BRACELETS
                    </NavLink>
                  </Col>
                  <Col
                    xs={5}
                    sm={5}
                    md={6}
                    lg={6}
                    className="dfl_finr_coll_bracelet_img no-padding adv-thumb-link desktop_view"
                  >
                    <img src={braceletsImg} alt="Earrings" />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs={12} sm={6} md={6} lg={6} className="content_left">
              <div className="banner-adv zoom-image">
                <Row className="pendants_bg  w-100 m-auto">
                  <Col
                    xs={5}
                    sm={5}
                    md={6}
                    lg={6}
                    className="ring_left_inner no-padding adv-thumb-link"
                  >
                    <img src={pendantsImg} alt="Rings" className="mt-0" />
                  </Col>
                  <Col
                    xs={7}
                    sm={7}
                    md={6}
                    lg={6}
                    className="content_left_inner"
                  >
                    <h2> PENDANTS</h2>
                    <p>
                      Stunning, classy and spectacular. Add glamour to a simple
                      chain or necklace by adding our unique designed pendants.
                    </p>
                    <NavLink to="/jewelry/pendants" className="cool-link">
                      shop Pendants
                    </NavLink>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs={12} sm={6} md={6} lg={6} className="content_right">
              <div className="banner-adv zoom-image">
                <Row className="guid_bg  w-100 m-auto">
                  <Col
                    xs={7}
                    sm={7}
                    md={6}
                    lg={6}
                    className="content_right_inner"
                  >
                    <h2>SIZE GUIDE</h2>
                    <p>
                      Our size guide will help you with ease to help you find
                      the right size for your jewelry.
                    </p>
                    <NavLink
                      to="#"
                      className="cool-link"
                      onClick={() =>
                        window.open(
                          'https://venice.demobw.com/assets/images/eng-ring/Ring-sizing-guide.pdf',
                          '_blank',
                        )
                      }
                    >
                      Ring Size Guide
                    </NavLink>
                  </Col>
                  <Col
                    xs={5}
                    sm={5}
                    md={6}
                    lg={6}
                    className="dfl_finr_coll_bracelet_img no-padding adv-thumb-link ringsize_left_inner "
                  >
                    <img src={size_guideImg} alt="Earrings" />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default FineCollection;
